import { ReactElement } from 'react';
import styles from './ui-menu-header.module.scss';
import { UISpacer } from '../ui-spacer';
import { UIAvatar } from '../ui-avatar';

type UIMenuHeaderProps = {
    image?: string;
    text: string;
    subText?: string;
};

export function UIMenuHeader(props: UIMenuHeaderProps): ReactElement {
    const { image, text, subText } = props;

    return (
        <div className={styles.container}>
            {image && (
                <>
                    <UIAvatar img={image} alt="avatar" size={36} />
                    <UISpacer />
                </>
            )}

            <div className={styles.textContainer}>
                <div className={styles.text}>{text}</div>
                {subText && <div className={styles.subText}>{subText}</div>}
            </div>
        </div>
    );
}
